import { AuthActionTypes, AuthActions } from '@app-stores/actions/auth.action';
import * as errorHandler from '@app-shared/utils/error-handler';
export interface State {
	error: any;
	passwordChanged: boolean;
	passwordChangePending: boolean;
}
export const initialState: State = {
	error: null,
	passwordChanged: false,
	passwordChangePending: false
};
export function reducer(state = initialState, action: AuthActions): State {
	switch (action.type) {
		case AuthActionTypes.ChangePassword: {
			return {
				...state,
				error: null,
				passwordChanged: false,
				passwordChangePending: true
			};
		}
		case AuthActionTypes.ChangePasswordSuccess: {
			const access_token = action.payload['access_token'];
			// const refresh_token = action.payload['refresh_token'];
			const user = JSON.stringify(action.payload['user']);
			localStorage.setItem('access_token', access_token);
			// localStorage.setItem('refresh_token', refresh_token);
			localStorage.setItem('user', user);
			return {
				...state,
				error: null,
				passwordChanged: true,
				passwordChangePending: false
			};
		}
		case AuthActionTypes.ChangePasswordFailure: {
			return {
				...state,
				error: errorHandler.getHttpError(action.payload),
				passwordChanged: false,
				passwordChangePending: false
			};
		}
		default: {
			return state;
		}
	}
}
export const getError = (state: State) => state.error;
export const getPasswordChangePending = (state: State) => state.passwordChangePending;
export const getPasswordChanged = (state: State) => state.passwordChanged;
